import { ContentButton } from './content/button';
import { InternTrustItem } from './intern/trust-item';

/**
 * Model definition for TrustElement
 */
export interface TrustElement {
  __contentType: 'trust-element';
  id: string;
  publication_id?: number;
  publication_date?: Date;
  publication_state?: 'draft' | 'live' | 'archived' | 'unpublished' | 'preview';
  name?: string;
  items?: Array<InternTrustItem>;
  cta?: ContentButton;
}

export function isTrustElement(obj: { __contentType?: string }): obj is TrustElement {
  return obj.__contentType === 'trust-element';
}
